module.exports = __webpack_public_path__ + "media/images/adverts/linkedin-b7fc12df2ad32ee90680987d658e22dd.jpg";